import React from 'react';
import { Box, Flex, VStack, Text, Icon } from '@chakra-ui/react';
import { ViewOffIcon } from '@chakra-ui/icons';
import LaunchPreviewButton from 'src/components/atoms/launch-preview-button';

interface PreviewModeBannerProps {
  launchPreviewRequested: boolean;
  variant?: 'default' | 'admin';
}

const PreviewModeBanner = ({
  launchPreviewRequested,
  variant = 'default',
}: PreviewModeBannerProps) => {
  const isAdmin = variant === 'admin';

  return (
    <Box
      bgGradient="linear(90deg, lomaGreen.400, lomaGreen.800)"
      boxShadow="lg"
      borderBottom="1px solid"
      borderColor="whiteAlpha.200"
    >
      <Flex justify="center" align="center" px={6} py={4} maxW="1200px" mx="auto" gap={6}>
        <Box
          bg="whiteAlpha.200"
          borderRadius="full"
          p={2}
          backdropFilter="blur(10px)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          w="40px"
          h="40px"
          flexShrink={0}
        >
          <Icon as={ViewOffIcon} w={5} h={5} color="white" />
        </Box>
        <VStack spacing={0} align="start">
          <Text color="white" fontWeight="bold" fontSize="md" lineHeight="1.2">
            {isAdmin ? 'Private Preview' : 'Preview Mode'}
          </Text>
          <Text color="whiteAlpha.800" fontSize="sm" lineHeight="1.2">
            {isAdmin ? 'Admin access to preview site' : 'The site is only visible to you'}
          </Text>
        </VStack>
        <LaunchPreviewButton launchPreviewRequested={launchPreviewRequested} size="sm" />
      </Flex>
    </Box>
  );
};

export default PreviewModeBanner;
